module.exports = __webpack_public_path__ + "img/35.d2811b8c.jpg";